import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Container, Box, Grid, Button, Avatar, Typography } from "@material-ui/core";
import { List, ListItem, ListItemIcon, ListItemText } from "@material-ui/core";
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import LinkMat from '@material-ui/core/Link';
import AuthService from "../../../../services/auth.service";
import {Link} from "react-router-dom";



const useStyles = makeStyles((theme) => ({
  menuLink: {
      display: 'flex',
      color: 'white',
      width: '100%'
  },
}));

export default function Profile(props)  {
  const classes = useStyles();
  const logOut = () => {
    AuthService.logout();
  };

  return (
    <React.Fragment>
      <Container>
        <Box pb={10}>
          <Grid
            className="profile_grid"
            container
            direction="row"
            justify="center"
            alignItems="center"
          >
            <Avatar className="avatar">
              VM
            </Avatar>
            <Typography variant="p" component="p">
              {props.currUser.name}
            </Typography>
            <Button >
              EDIT PROFILE
            </Button>
          </Grid>

          <List dense>
            <ListItem
              button
              style={{
                borderBottom: '1px solid rgba(255,255,255,0.2)',
                padding: '5px 0'
              }}
            >
              <Link to={"/tags/"+props.currUser.id} className={classes.menuLink}>
                <ListItemText primary="MY TAGS" />
                <ListItemIcon style={{ minWidth: 'auto' }}>
                  <ArrowForwardIosIcon style={{ color: '#747474', fontSize: '1rem' }}/>
                </ListItemIcon>
              </Link>
            </ListItem>
            <ListItem
              button
              style={{
                borderBottom: '1px solid rgba(255,255,255,0.2)',
                padding: '5px 0'
              }}
            >
              <Link to={"/"+props.currUser.id+"/tickets"} className={classes.menuLink}>
                <ListItemText primary="MY TICKETS" />
                <ListItemIcon style={{ minWidth: 'auto' }}>
                  <ArrowForwardIosIcon style={{ color: '#747474', fontSize: '1rem' }}/>
                </ListItemIcon>
              </Link>
            </ListItem>
            <ListItem
              button
              style={{
                borderBottom: '1px solid rgba(255,255,255,0.2)',
                padding: '5px 0'
              }}
            >
              <Link to={"/"+props.currUser.id+"/deals"} className={classes.menuLink}>
                <ListItemText primary="MY DEALS" />
                <ListItemIcon style={{ minWidth: 'auto' }}>
                  <ArrowForwardIosIcon style={{ color: '#747474', fontSize: '1rem' }}/>
                </ListItemIcon>
              </Link>
            </ListItem>
            <ListItem
              button
              style={{
                borderBottom: '1px solid rgba(255,255,255,0.2)',
                padding: '5px 0'
              }}
            >
              <Link to={"/"+props.currUser.id+"/orders"} className={classes.menuLink}>
                <ListItemText primary="MY ORDERS" />
                <ListItemIcon style={{ minWidth: 'auto' }}>
                  <ArrowForwardIosIcon style={{ color: '#747474', fontSize: '1rem' }}/>
                </ListItemIcon>
              </Link>
            </ListItem>
            <ListItem
                button
                style={{
                  borderBottom: '1px solid rgba(255,255,255,0.2)',
                  padding: '5px 0'
                }}
            >
              <ListItemText primary="SETTINGS" />
              <ListItemIcon style={{ minWidth: 'auto' }}>
                <ArrowForwardIosIcon style={{ color: '#747474', fontSize: '1rem' }}/>
              </ListItemIcon>
            </ListItem>
            <ListItem
              button
              style={{
                padding: '5px 0'
              }}
            >
              <ListItemText primary="HELP" />
              <ListItemIcon style={{ minWidth: 'auto' }}>
                <ArrowForwardIosIcon style={{ color: '#747474', fontSize: '1rem' }}/>
              </ListItemIcon>
            </ListItem>
            <ListItem
              button
              style={{
                padding: '5px 0'
              }}
            >
              <LinkMat href="/" onClick={logOut} >
                <ListItemText primary="LOGOUT" />
              </LinkMat>
            </ListItem>
          </List>
        </Box>
      </Container>
    </React.Fragment>
  );
}
